import { ANALYTICS, GENERIC } from "@data"
import { get, logTool } from "@jsUtils"

const log = logTool(false)

/**
 * Get props from an object list, convert them to data-[key]
 * @param  {object} list - key value data from Analytics constant
 * @return {object}      object suitable for data attributes on the link
 */
const convertToDataProps = list => {
  if (list) {
    const propObj = {}
    Object.keys(list).forEach(v => {
      propObj[`data-${v}`] = list[v]
    })
    return propObj
  }
  return {}
}

/**
 * Get a standard format analytics tag based on scope and content
 * @param  {string} scope   - string for ANALYTICS constant category
 * @param  {string} content - sting content in format CONTENT=[string]
 * @return {object}         - object in tag format for creating props
 */
const getGeneric = (scope, data) => {
  // log("getGeneric", scope, data, GENERIC)
  return GENERIC.CONTENT(scope, data.content)
}

const isContent = data => {
  return typeof data === "object" && data !== null && data.content
}

/**
 * Get the Analytics data from the Analytics constant by key path
 * @param  {string} scope a scope pointer to the top level grouping in the ANALYTICS constant
 * @param  {string|object} path a dot delimited path from the analytics constant OR a { content: [string] }
 * @return {object}      an object of analytics keys
 */
const getAnalytics = (scope, path) => {
  let contentTags
  let fullPath
  let data

  if (typeof path === "string") {
    fullPath = `${scope.toUpperCase()}.${path.toUpperCase()}`
    data = get(ANALYTICS, fullPath)
  }

  // if data is undefined, we do not have a matching key
  // we can still try to provide content, but really only if we have
  // a scope and defined content
  // scope = 'a valid key from analytics constants'
  // adata = { content: {string} }
  if (!data && isContent(path)) {
    contentTags = getGeneric(scope, path)
  }

  const returnData = data || contentTags

  log("getAnalytics(path)", { scope, path, fullPath, data, contentTags, returnData })
  return returnData
}

export default {
  convertToDataProps,
  getAnalytics,
  getGeneric
}
